import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch } from "../../../redux/hooks";
import { generateBarcode } from "../../../redux/api/admin.api";

import { DropdownValue } from "../../../components/misc/Dropdown";
import ContentCard from "../../../components/misc/ContentCard";
import CustomButton from "../../../components/CustomButton";

import AutoBarcode from "./AutoBarcode";
import NodesBarcode from "./NodesBarcode";

const buttonTypes = [
  {
    id: 1,
    label: "Genereaza nr. auto",
  },
  {
    id: 2,
    label: "Genereaza nod",
  },
];

function GenerateBarcode() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [type, setType] = useState<number | null>(1);
  const [selectedValue, setSelectedValue] = useState<DropdownValue | null>(
    null,
  );

  const handleGenerateBarcode = () => {
    dispatch(
      generateBarcode({
        type: type,
        id: selectedValue?.id,
      }),
    );
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <ContentCard>
      <div className="mb-5 flex flex-wrap items-center gap-3">
        {buttonTypes.map(({ id, label }) => (
          <CustomButton
            key={id}
            variant={type === id ? "contained" : "outlined"}
            onClick={() => setType(id)}>
            {label}
          </CustomButton>
        ))}
      </div>

      {type === 1 && (
        <AutoBarcode
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
        />
      )}

      {type === 2 && (
        <NodesBarcode
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
        />
      )}

      <div className="flex justify-between gap-4">
        <CustomButton variant="outlined" onClick={handleGoBack}>
          Inapoi
        </CustomButton>
        <CustomButton
          variant="contained"
          icon="BARCODE"
          onClick={handleGenerateBarcode}>
          Genereaza
        </CustomButton>
      </div>
    </ContentCard>
  );
}

export default GenerateBarcode;
